<script>
	import { Router, Route, navigate } from "svelte-routing";
	import ServerErrorPage from "./pages/ServerErrorPage.svelte";
	import DestContactPage from "./pages/destination/DestContactPage.svelte";
	import DestAddressPage from "./pages/destination/DestAddressPage.svelte";
	import PackagePage from "./pages/package/PackagePage.svelte";
	import PackageNotesPage from "./pages/package/PackageNotesPage.svelte";
	import OrderReviewPage from "./pages/order/OrderReviewPage.svelte";
	import Title from "./components/title/Title.svelte";
	import Snackbar from "./components/snackbar/Snackbar.svelte";
	import ShipperContactPage from "./pages/shipper/ShipperContactPage.svelte";
	import ShipperListPage from "./pages/shipper/ShipperListPage.svelte";
	import ShipperAddressPage from "./pages/shipper/ShipperAddressPage.svelte";
	import ShipperNamePage from "./pages/shipper/ShipperNamePage.svelte";
	import Loading from "./components/loading/Loading.svelte";
	import OriginPage from "./pages/order/OriginPage.svelte";
	import DestinationPage from "./pages/order/DestinationPage.svelte";
	import OriginListPage from "./pages/order/OriginListPage.svelte";
	import PickupTimePage from "./pages/pickup/PickupTimePage.svelte";
	import PickupOriginPage from "./pages/pickup/PickupOriginPage.svelte";
	import PickupOrdersPage from "./pages/pickup/PickupOrdersPage.svelte";
	import PickupAddressPage from "./pages/pickup/PickupAddressPage.svelte";
	import PickupPaymentPage from "./pages/pickup/PickupPaymentPage.svelte";
	import PickupReviewPage from "./pages/pickup/PickupReviewPage.svelte";

	let pathname = window.location.pathname;
	const path = pathname.split("/");
	if (path[1] == "order" && path[2] != "review") {
		sessionStorage.removeItem("order");
		const session = path[2];
		sessionStorage.setItem("session", session);
		sessionStorage.setItem("next", path[3]);
		navigate("/origin");
	}
	switch (pathname) {
		case "/address":
			navigate("/shipper/list");
			break;
	}
</script>

<style lang="scss">
	.page {
		padding-top: 56px;
	}
</style>

<Title />
<div class="page">
	<Loading />
	<Router>
		<Route path="origin" component={OriginPage} />
		<Route path="origin/list" component={OriginListPage} />

		<Route path="destination" component={DestinationPage} />
		<Route path="destination/contact" component={DestContactPage} />
		<Route path="destination/address" component={DestAddressPage} />

		<Route path="shipper/list" component={ShipperListPage} />
		<Route path="shipper/contact" component={ShipperContactPage} />
		<Route path="shipper/address" component={ShipperAddressPage} />
		<Route path="shipper/name" component={ShipperNamePage} />
		<Route path="package" component={PackagePage} />
		<Route path="package/notes" component={PackageNotesPage} />

		<Route path="pickup/time" component={PickupTimePage} />
		<Route path="pickup/origin" component={PickupOriginPage} />
		<Route path="pickup/address" component={PickupAddressPage} />
		<Route path="pickup/orders" component={PickupOrdersPage} />
		<Route path="pickup/payment" component={PickupPaymentPage} />
		<Route path="pickup/review" component={PickupReviewPage} />

		<Route path="order/review" component={OrderReviewPage} />

		<Route path="server-error" component={ServerErrorPage} />
	</Router>
</div>
<Snackbar />
